<template>
  <div id="user">
    <div class="btnBoxs">
      <div>
        <span style="font-size: 0.75rem;">匹配模式:</span>
      <el-select v-model="pattern" filterable placeholder="请选择" style="width: 300px ;" size='mini'>
        <el-option v-for="(item,index) in patternAll" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      </div>
      <div style="margin-left:60px">
        <span style="font-size: 0.75rem;">关键字:</span>
      <el-input v-model="keywords" autocomplete="off" style="width: 200px ;" size='mini'>
      </el-input>
      </div>
      <div class="btn">
        <el-button type="primary" size='mini'  icon="el-icon-search" @click="pagefeed(1)">搜 索</el-button>
        <el-button  size='mini'  icon="el-icon-circle-close" @click="pagefeed()">清 空</el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="120">
      </el-table-column>
      <el-table-column prop="tel" label="电话" show-overflow-tooltip width="120">
      </el-table-column>
      <el-table-column prop="department" label="部门" show-overflow-tooltip width="120">
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip width="120">
        <template slot-scope='scope'>
          <p v-if="scope.row.status !='1'" style="color: red;">未验证</p>
          <p v-else>已验证</p>
        </template>
      </el-table-column>
      <el-table-column prop="login_times" label="登录次数">
      </el-table-column>
      <el-table-column prop="account" label="账号" width="180" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="pwd" label="密码" show-overflow-tooltip width="170">
      </el-table-column> -->
      <el-table-column prop="register_time" label="注册时间" show-overflow-tooltip width="170">
      </el-table-column>
      <el-table-column prop="last_login_time" label="最后一次登录时间" show-overflow-tooltip width="170">
      </el-table-column>
      <el-table-column label="操作" width="230"  fixed="right">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="primary" icon="el-icon-edit" size="small">授 权</el-button>
          <el-button @click="delentClick(scope.row)" type="danger" icon="el-icon-delete" size="small">删 除</el-button>
          <!-- <el-button @click="cutClick(scope.row)" type="success" icon="el-icon-guide" size="small">切换用户</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag  title="授权" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="sizeForm" label-width="80px" inline>
        <el-form-item label="角色">
          <el-select v-model="sizeForm.values" placeholder="请选择" multiple @change="$forceUpdate()">
            <el-option v-for="item in options" :key="item.GZL_ROLE_id_PK" :label="item.name" :value="item.GZL_ROLE_id_PK" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="sizeForm.department" placeholder="请选择" value-key='id'>
            <el-option v-for="item in department" :key="item.GZL_DEPARTMENT_id_PK" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位">
          <el-select v-model="sizeForm.is_leader" placeholder="请选择" >
            <el-option v-for="(item,index) in optionT" :key="index" :label="item.values" :value="item.values" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="sizeForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="sizeForm.tel" placeholder="电话"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="sizeForm.pwd" placeholder="密码" @blur="getPassword"></el-input>
        </el-form-item>

      </el-form>
      <el-button type="primary" @click="confirm()">确 定</el-button>
      <el-button @click="Destroy()">取 消</el-button>
    </el-dialog>
    <div class="block">
      <!-- 分页 -->
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout="prev, pager, next, slot, jumper" :total="currentPage4">
        <!-- <span style="width: 100px;">
          <el-input v-model.number="currentPage" @input="handlePageSize" size='mini'></el-input>条/页
        </span> -->
      </el-pagination>
    </div>
  </div>
</template>

<script scoped>
  import {
    DataShow,
    pagepower,
    userdata,
    companystaff,
    department,
    LoginView
  } from '../../static/API/API.js'
  export default {
    data() {
      return {
        options: [],
        department: [],
        //
        tableData: [],
        currentPage4: 0,
        currentPage1: 1,
        currentPage: 10,
        pageSize: 1,
        keywords: '',
        pattern: '',
        patternAll: [{
          value: 'name',
          label: '姓名'
        }, {
          value: 'tel',
          label: '电话'
        }, {
          value: 'account',
          label: '账号'
        }],
        optionT: [{
            values: '部门经理'
          },
          {
            values: '部门成员'
          }
        ],
        dialogVisible: false,
        //from表单数据
        sizeForm: {
          values: [],
        },
        tablForm: {
          id: '',
          department: '',
        },
        multipleSelection: [],
        //
        pwds:false,
        loading:false,
        TableHeight:490
      }
    },
    methods: {
      // 切换用户
      cutClick(row){
        // An highlighted block
        let routeUrl = this.$router.resolve({
                path:'/',
                name:'ScmLogin',
                query:{
                  password: row.pwd,
                  account:row.account
                }
              })
              window.open(routeUrl.href, '_blank');
        let params = new URLSearchParams();
        params.append('account', row.account);
        params.append('password', row.pwd);
        this.$axios.get(LoginView,{params}).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
        })
      },
      // 选择删除
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      //确定授权
      confirm() {
        console.log(this.tablForm);
        console.log(this.sizeForm);
        let params = new URLSearchParams();
        params.append('ope_type', 'update')
        params.append('user_id', this.tablForm.id)
        params.append('name', this.sizeForm.name)
        params.append('role_id', this.sizeForm.values)
        params.append('password', this.sizeForm.pwd)
        params.append('department', this.sizeForm.department)
        if (this.sizeForm.is_leader == '部门经理') {
          params.append('is_leader', 1); //领导身份
        } else {
          params.append('is_leader', 0); //成员身份
        }
        this.$axios.post(companystaff, params).then(res => {
          console.log(res);
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
          this.dialogVisible = false
        })

      },
      // 获取角色
      role() {
        let params = new URLSearchParams()
        params.append('page_size', 'all')
        params.append('page_number', 1)
        this.$axios.get(pagepower, {
          params
        }).then(res => {
          this.options = res.data.result
        })
      },
      // 获取部门
      departmentS() {
        let params = new URLSearchParams()
        params.append('page_size', 'all')
        params.append('page_number', 1)
        this.$axios.get(department, {
          params
        }).then(res => {
          this.department = res.data.result
        })
      },
      // 编辑授权
      handleClick(row) {
        this.dialogVisible = true
        this.tablForm.department = row.department
        this.tablForm.id = row.id
        this.sizeForm = row
        this.sizeForm.values =[]
        if (this.sizeForm.is_leader == 0){
          this.sizeForm.is_leader ='部门成员'
        } else {
          this.sizeForm.is_leader ='部门经理'
        }
        this.options.forEach(e => {
          row.role_id.split(",").forEach(i=>{
            if (e.GZL_ROLE_id_PK == i) {
              this.sizeForm.values.push(e.GZL_ROLE_id_PK)
            }
          })
        })
      },
      delentClick(row) {
        let params = new URLSearchParams()
        params.append('ope_type', 'delete')
        params.append('user_id', row.id)
        this.$axios.post(companystaff, params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
        })
      },
      pagefeed(e) {
        this.loading = true
        let params = new URLSearchParams()
        params.append('field', this.pattern)
        params.append('keyword', this.keywords)
        params.append('page_size', this.currentPage)
        if(e){
          params.append('page_number', 1)
        }else{
          params.append('page_number', this.currentPage1)
        }
        this.$axios.get(companystaff,{params}).then(res => {
          console.log(res);
          this.tableData = res.data[0]['pagedata']
          this.currentPage4 = Number(res.data[0]['PageNums'])
          this.keywords = ''
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
      },
      getPassword(){
        if(this.sizeForm.pwd.length < 6){
          this.$message({
            message: '请至少输入6位数密码',
            type: 'warning',
            duration: 1000,
            showClose: true,
          });
        }
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed()
      },
      // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
      handlePageSize() {
        if (!this.pageSize) {
          this.pageSize = 7
          this.pagefeed()
        } else {
          this.pagefeed()
        }
      },
      Destroy() {
        this.dialogVisible = false
        this.sizeForm = {}
        this.pagefeed()
      },
      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 223;//数值"140"根据需要调整
    })
      },
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    mounted() {
      this.companyid =sessionStorage.getItem('companyid')
      this.pagefeed()
      this.role()
      this.departmentS()
      this.getHeight()
    },
  }
</script>

<style scoped>
  .el-pagination__total {
    display: none;
  }

  .block {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .pageSizeBorder {
    width: 1rem !important;
  }

  .el-pagination__jump {
    margin-left: 2.75rem;
  }

  .el-pagination .el-input__inner {
    height: 1.75rem !important;
  }
  .btnBoxs{
    display: flex;
    margin-bottom: 15px;
  }
  .btn{
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user.vue